export const enum StorageKey {
  User = 'mga-front-user',
}
